import type { SprintState } from "../../../entities/sprint-planning/model/use-sprints";

// Only the colours are fixed here; what the badge says is screen text.
export const sprintStateMeta: Record<SprintState, { badgeClassName: string; dotClassName: string; labelKey: string }> = {
  active: {
    badgeClassName: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
    dotClassName: "bg-emerald-500",
    labelKey: "sprint.active",
  },
  closed: { badgeClassName: "bg-muted text-muted-foreground", dotClassName: "bg-muted-foreground/40", labelKey: "sprint.closed" },
  overdue: {
    badgeClassName: "bg-amber-500/15 text-amber-600 dark:text-amber-400",
    dotClassName: "bg-amber-500",
    labelKey: "sprint.overdue",
  },
  planned: { badgeClassName: "bg-muted text-muted-foreground", dotClassName: "bg-muted-foreground/40", labelKey: "sprint.planned" },
};
